<template>
<the-header></the-header>
<div class="container">
    <b class="float" @click="formToggle">
        <router-link to="" >
            <h2 class="fa fa-plus my-float text-white"></h2>
        </router-link>
    </b>
    <div class="row">
        <search-action heading="Clients" @searchlist="getlist"></search-action>
    </div>
    <transition name="msg" mode="out-in">
    <strong class="text-success">{{msg}}</strong>
    </transition>
    <add-client v-if="formVisible" @close="formToggle" @load="getlist" :update="UpdateData" @msg="showMessgae"></add-client>
    <div class="py-2 table_div">
        <table class="table table-striped border">
        <thead>
            <tr>
            <th scope="col"></th>
            <th scope="col">Name</th>
            <th scope="col">Phone Number</th>
            <th scope="col">Email</th>
            <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="getClients.length==0"><td colspan="5" class="text-center">No Clients Are Avaiable. <b @click="fromToggle"> Add A Client</b></td>
            </tr>
            <tr v-else v-for="data in getClients" :key="data.int_party_id">
            <th scope="row">{{data.int_party_id}}</th>
            <td>{{data.txt_name}}</td>
            <td>{{data.txt_mobile_whatsapp}}</td>
            <td>{{data.txt_email}}</td>
            <td><base-button mode="icon" @click="updateClient(data.int_party_id)"><strong class="fas fa-edit" ></strong></base-button>
            </td>
            </tr>
            <tr style="text-align:right" >
                <td colspan="5" >
                    <ul class='pagination' >
                       <li class='page-item' :class="{active : item==getActive}" v-for="(item, index)  in getPagination" v-bind:key="index"><a href="#" class='page-link btn btn-sm' @click="pageredirect(item)" >{{getPaginationText[index]}}</a></li>
                    </ul>
                </td>
            </tr>
        </tbody>
    </table>
    </div>
</div>
</template>
<script>
import AddClient from './AddClient.vue'
export default {
    components:{
        AddClient,
    },
    data(){
        return{
            formVisible:false,
            UpdateData:null,
            msg:null,
            search:null,
        }
    },methods:{
        pageredirect(id){
            this.getlist(id)
        },
        getlist(pn=1,option=null){
            try{
                this.$store.dispatch('admin/getClient',{page_no:pn,option:option});
            }catch(error){
               console.log('error'+error)
            }
        },
        updateClient(id){
            this.formVisible=true;
            this.UpdateData=id;
        },
        formToggle(){
            this.UpdateData=null;
            this.formVisible=!this.formVisible
        },
        showMessgae(msg){
            this.msg=msg;
            setTimeout(()=>{
                this.msg=null;
            },3000);
        },

    },
    computed:{
        getActive(){
            return this.$store.getters['admin/getActive'];
        },
        getClients(){
            if(this.$store.getters['admin/getClients']==null){
                return 1;
            }else{
                return this.$store.getters['admin/getClients'];
            }
            
        },
        getPagination(){
            return this.$store.getters['admin/getpagination'];
        },
        getPaginationText(){
            return this.$store.getters['admin/getpagination_text']
        }
    },
    created(){
        this.getlist();
    }
}
</script>
<style  scoped>
 
</style>